import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
import '../session-sdo';
import debounce from 'debounce';
import {GroupLevelsFilter} from '../group-levels-filter';

/**
 * @summary MultiClassroomSelectGroupFilter
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('multi-classroom-select-group-filter')
class MultiClassroomSelectGroupFilter extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of MultiClassroomSelectGroupFilter.
   */
  constructor() {
    super();

    this.translations = translations;
    this.searchDebounce = debounce(this.search, 250);
  }

  /**
   * @readonly
   */
  static is = 'multi-classroom-select-group-filter';

  @property({type: Number})
  ['group-id'] = 0;

  @property({type: Number})
  maxLevel = 0;

  @property({type: Array})
  groups = [];

  @property({type: Array, attribute: false})
  selected = [];

  @property({type: Boolean})
  disabled = false;

  async selectGroup(groupIndex, itemIndex) {
    const selectedGroup = this.groups[groupIndex].groups[itemIndex];
    this.groups = await this.groupLevelsFilter.updateGroup(groupIndex, selectedGroup);
    if (selectedGroup.level - 1 === this.maxLevel) {
      this.dispatchEvent(new CustomEvent('search-filter-selected', {
        composed: true,
        bubbles: true,
        detail: selectedGroup
      }));
    }
  }

  async connectedCallback() {
    super.connectedCallback();

    const state = storeInstance.getState();
    const groupInfo = state[sdoNs.SESSION].group_info;
    this.maxLevel = parseInt(state[sdoNs.SESSION].settings.tier_structure.levels, 10);
    this.groupLevelsFilter = new GroupLevelsFilter(this.maxLevel, true);
    this.groups = await this.groupLevelsFilter.loadAllGroupsByParentPath(groupInfo);
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default MultiClassroomSelectGroupFilter;
